
if(!customElements.get('point-slideshow')) {
    class pointSlideshow extends HTMLElement {
        constructor() {
            super()
            this.args = {
                wrapAround: true,
                cellAlign: 'left',
                cellSpacing: 10,
                pageDots: false,
                contain: true,
                // fade: fade,
                autoPlay: 1000 * 10,
                prevNextButtons: false,
                cellSelector: '.point-slide',
                pauseAutoPlayOnHover: false,
                on: {}
            };
        }
        connectedCallback() {
            const container = this
            setTimeout(()=>{
            this.slideshow = container.querySelector('.point-container')
            this.slideshow_slides = this.slideshow.querySelectorAll('.point-slide')
            let prevBtn = container.querySelector('.slide-prev')
            let nextBtn = container.querySelector('.slide-next')
            let tabs = container.querySelectorAll('.point-tab-item')
            const tabContainer = container.querySelector('.point-tab'); // 滚动的容器
            const containerWidth = tabContainer.clientWidth; // 容器的可视宽度
            const tabWidth = tabs[0].clientWidth; // 当前 tab 的宽度
            this.args.on.change = function(index) {
                tabs.forEach(tab=>tab.classList.remove('active'))
                tabs[index].classList.add('active')
                setTimeout(() => {
                    tabMoveToView(tabs[index])
                }, 300);
            }
            const flkty = new Flickity(this.slideshow, this.args);
            tabs.forEach((tab,index) => {
                tab.addEventListener('click',()=>{
                    flkty.select(index)
                    tabs.forEach(t=>t.classList.remove('active'))
                    tab.classList.add('active')
                    if(window.innerWidth < 768) {
                        // tab.scrollIntoView({ behavior: "smooth", inline: "center" });
                        tabMoveToView(tab)
                    }
                })
            }) 
            prevBtn.addEventListener('click',()=>{
                flkty.previous()
            })
            nextBtn.addEventListener('click', () => {
                flkty.next()
            })
            function tabMoveToView(tab) {
                // tab.scrollIntoView({ behavior: "smooth", inline: "center" });
                const tabOffsetLeft = tab.offsetLeft; // 当前 tab 距离容器左侧的偏移
                // 计算滚动距离，让 tab 居中
                const scrollLeft = tabOffsetLeft - (containerWidth / 2) + (tabWidth / 2);
                // 平滑滚动
                tabContainer.scrollTo({
                    left: scrollLeft,
                    behavior: 'smooth'
                });
            }
            function onInterSection(entries, observer) {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        flkty.playPlayer()
                        observer.unobserve(entry.target)
                    }else {
                        flkty.pausePlayer()
                    }
                });
            }
            const observer = new IntersectionObserver(onInterSection, {
                root: null,
                rootMargin: '0px',
                threshold: 0.1
            });
            observer.observe(this.slideshow)
            },50)
        }
    }
    customElements.define('point-slideshow', pointSlideshow)
}